import { render, staticRenderFns } from "./Oxford.vue?vue&type=template&id=6aa301fb&scoped=true"
import script from "./Oxford.vue?vue&type=script&lang=js"
export * from "./Oxford.vue?vue&type=script&lang=js"
import style0 from "./Oxford.vue?vue&type=style&index=0&id=6aa301fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa301fb",
  null
  
)

export default component.exports